import { rei } from "@/services/api"

class AverbacoesService {
  static incluirAverbacao (registro_id, averbacao) {
    averbacao.texto = averbacao.texto_averbacao
    averbacao.data = averbacao.data_averbacao

    return rei.post(`averbacoes`, { registro_id, ...averbacao })
  }

  static getAverbacaoByRegistroId (registro_id) {
    return rei.get(`averbacoes?registro_id=${registro_id}`).then(res => res.data)
  }

  static atualizarAverbacao (documento_id, averbacao) {
    averbacao.texto = averbacao.texto_averbacao
    averbacao.data = averbacao.data_averbacao
    return rei.put(`averbacoes/${documento_id}`, { ...averbacao })
  }

  static excluirAverbacao (documento_id) {
    return rei.delete(`averbacoes/${documento_id}`)
  }

  static excluirEmLote (documento_id) {
    return rei.post(`exclusao-lote-docs`, { documentoIds: [ ...documento_id ] })
  }

  static atualizarAverbacaoGED (averbacao) {
    return rei.put(`averbacoes-ged`, { ...averbacao })
  }
}

export default AverbacoesService
